"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withStyles_1 = require("../decorators/withStyles");

var ControllableProgress_styles_1 = require("./ControllableProgress.styles");

var classNames = require("classnames");

var baseProps_1 = require("../assets/baseProps");

var memoize_one_1 = require("@stoplight/memoize-one");

var typeMapValue;

(function (typeMapValue) {
  typeMapValue[typeMapValue["blank"] = 0] = "blank";
  typeMapValue[typeMapValue["success"] = 1] = "success";
  typeMapValue[typeMapValue["warning"] = 0.66] = "warning";
  typeMapValue[typeMapValue["error"] = 0.33] = "error";
})(typeMapValue = exports.typeMapValue || (exports.typeMapValue = {}));

var animationDuration = 250;

var ControllableProgress =
/** @class */
function (_super) {
  __extends(ControllableProgress, _super);

  function ControllableProgress() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * ссылка на ноду тега <circle>, который мы анимируем
     */


    _this.circle = null;
    /**
     * Текущее состояние круга
     */

    _this.currentValue = null;
    /**
     * Последнее пришедшее состояние
     */

    _this.lastValue = null;
    /**
     * флаг, что сейчас происходит анимация
     */

    _this.animationGoes = false;
    /**
     * Очередь анимаций, для плавного изменения при быстром изменении состояния прогресса
     */

    _this.animationsQueue = [];
    /**
     * расчитываем статические значения окружности (посчитаются один раз, пока не изменен размер)
     */

    _this.getStaticParams = memoize_one_1.default(function (size, propsThickness) {
      var dimensions = {
        width: size,
        height: size
      };
      var thickness = propsThickness || size / 5;
      var origin = size;
      var radius = (size - thickness) / 2;
      var viewBox = size / 2 + " " + size / 2 + " " + size + " " + size;
      var circumference = 2 * Math.PI * radius;
      return {
        dimensions: dimensions,
        thickness: thickness,
        origin: origin,
        radius: radius,
        viewBox: viewBox,
        circumference: circumference
      };
    });
    _this.getDynamicDrawingParams = memoize_one_1.default(function (value, circumference) {
      return {
        strokeDasharray: circumference.toFixed(3),
        strokeDashoffset: ((1 - value) * circumference).toFixed(3) + "px"
      };
    });
    /**
     * Управление анимацией. Добавляет в список анимаций и запускает
     */

    _this.processAnimation = function (animationState) {
      if (_this.animationGoes) {
        _this.animationsQueue.push(animationState);

        return;
      }

      var value = animationState.value,
          circumference = animationState.circumference;
      var _a = _this.props,
          classes = _a.classes,
          type = _a.type;
      _this.animationGoes = true;
      /* istanbul ignore next line */

      var start = window.performance && window.performance.now ? performance.now() : Date.now(); // участок 0.33 за 250 мс

      var duration = Math.abs(_this.currentValue - value) / 0.33 * animationDuration;

      var animate = function animate(now) {
        /* istanbul ignore next line */
        if (!now) {
          now = Date.now();
        }

        var delay = now - start;
        var timeFraction = delay / duration;

        if (timeFraction > 1) {
          timeFraction = 1;
        }

        var progress = _this.timing(timeFraction);

        _this.draw(progress, value, circumference);

        if (timeFraction !== 1) {
          requestAnimationFrame(animate);
          return;
        }

        _this.currentValue = value;

        _this.circle.setAttribute('class', classNames(classes.circle, classes[type]));

        _this.animationGoes = false; // Смотрим, пришли ли новые анимации пока делали эту

        var newAnimation = _this.animationsQueue.shift();

        if (newAnimation) {
          // если мы уже в нужном состоянии чистим список анимаций
          if (_this.currentValue === _this.lastValue) {
            _this.animationsQueue = [];
            return;
          }

          _this.processAnimation(newAnimation);
        }
      };

      requestAnimationFrame(animate);
    };
    /**
     * квадратичный easeOut
     */


    _this.timing = function (timeFraction) {
      return 1 - Math.pow(1 - timeFraction, 2);
    };
    /**
     * изменяем параметры circle в зависимости от прогресса анимации
     */


    _this.draw = function (progress, value, circumference) {
      var classes = _this.props.classes;
      var offset = (value - _this.currentValue) * progress + _this.currentValue;
      var strokeDasharray = circumference.toFixed(3);
      var strokeDashoffset = ((1 - offset) * circumference).toFixed(3) + "px";
      _this.circle.style.strokeDasharray = strokeDasharray;
      _this.circle.style.strokeDashoffset = strokeDashoffset;

      if (_this.props.type === 'determinate' && _this.props.color) {
        _this.circle.style.stroke = _this.props.color;
        return;
      }

      var className = '';

      switch (true) {
        case offset > typeMapValue.blank && offset <= typeMapValue.error:
          className = classes.error;
          break;

        case offset >= typeMapValue.error && offset <= typeMapValue.warning:
          className = classes.warning;
          break;

        case offset >= typeMapValue.warning && offset <= typeMapValue.success:
          className = classes.success;
          break;
      }

      _this.circle.setAttribute('class', classNames(classes.circle, className));
    };

    return _this;
  }

  ControllableProgress.prototype.render = function () {
    var _this = this;

    var propsValue = 0;
    var propsThickness = null;
    var color = null;
    var bgColor = null;
    var _a = this.props,
        _b = _a.size,
        size = _b === void 0 ? 20 : _b,
        _c = _a.type,
        type = _c === void 0 ? 'blank' : _c,
        classes = _a.classes;

    if (type === 'determinate') {
      var _d = this.props,
          value_1 = _d.value,
          thickness_1 = _d.thickness,
          propsColor = _d.color,
          propsBgColor = _d.bgColor;
      propsValue = value_1;
      propsThickness = thickness_1;
      color = propsColor;
      bgColor = propsBgColor;
    }

    var _e = this.getStaticParams(size, propsThickness),
        dimensions = _e.dimensions,
        thickness = _e.thickness,
        origin = _e.origin,
        radius = _e.radius,
        viewBox = _e.viewBox,
        circumference = _e.circumference;

    var value = type === 'determinate' ? propsValue : typeMapValue[type];

    if (this.currentValue === null) {
      this.lastValue = value;
      this.currentValue = value;
    }

    var isNewValue = this.lastValue !== value;
    var circleStyles = this.getDynamicDrawingParams(value, circumference);

    if (isNewValue || this.animationGoes) {
      circleStyles = null;
    }

    if (isNewValue) {
      this.lastValue = value;
      this.processAnimation({
        value: value,
        circumference: circumference
      });
    }

    var bgCircleClassname = classNames(!bgColor && classes.substrate);
    return React.createElement("div", __assign({}, baseProps_1.default(this.props), {
      "data-test-type": type,
      className: classes.base,
      style: dimensions
    }), React.createElement("svg", {
      viewBox: viewBox,
      style: dimensions
    }, React.createElement("circle", {
      className: bgCircleClassname,
      r: radius,
      cx: origin,
      cy: origin,
      fill: "none",
      stroke: bgColor,
      strokeWidth: thickness
    }), React.createElement("circle", {
      ref: function ref(circle) {
        /* istanbul ignore next line */
        if (circle) {
          _this.circle = circle;
        }
      },
      className: classNames(classes.circle, classes[type]),
      r: radius,
      cx: origin,
      cy: origin,
      fill: "none",
      stroke: color,
      strokeWidth: thickness,
      style: circleStyles
    })));
  };

  ControllableProgress = __decorate([withStyles_1.withStyles(ControllableProgress_styles_1.styles)], ControllableProgress);
  return ControllableProgress;
}(React.Component);

exports.default = ControllableProgress;